// extracted by mini-css-extract-plugin
module.exports = {"meter":"styles-module--meter--1X3mX","bar":"styles-module--bar--36MV4","arrow":"styles-module--arrow--3OaaJ"};